import TUICustomerPluginServer from './server';
import { isMessageInvisible } from './utils/index';
import CustomerServiceChat from './components/CustomerServiceChat/index-web.vue';

const TUICustomerServer = TUICustomerPluginServer.getInstance();

const isCustomerServicePluginMessage = TUICustomerServer.isCustomerServicePluginMessage.bind(TUICustomerServer);

const isCustomerConversation = TUICustomerServer.isCustomerConversation.bind(TUICustomerServer);

export {
  isCustomerServicePluginMessage,
  isMessageInvisible,
  CustomerServiceChat,
  isCustomerConversation
};

export default TUICustomerServer;
